import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { TextReveal } from './ui/Reveal';
import { posts } from '../data/posts';
export function JournalTeaser() {
  const preview = posts.slice(0, 3);
  return <section id="journal" className="relative z-10 w-full bg-[#F2F2F2] px-5 py-20 lg:px-8 lg:py-24" data-id="element-120" data-mp="3ha2nelunfya7">
      <div className="mx-auto w-full max-w-shell" data-id="element-121" data-mp="32ca9fy4r3hy4">
        <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center" data-id="element-122" data-mp="32ewjq5j10bk1">
          <h2 className="max-w-[620px] text-3xl font-semibold leading-tight text-[#2D2D2D] lg:text-[40px] lg:leading-[48.8px]" data-id="element-123" data-mp="379scx90014yq">
            <TextReveal data-id="element-124" data-mp="2yax4dq9hfis9">Thoughts on design &amp; growth.</TextReveal>
          </h2>
          <Button to="/blog" variant="solid" data-id="element-125" data-mp="2yd1guwlg5q45">
            Read the journal
          </Button>
        </div>

        <ul className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-126" data-mp="wjtwv9uw2kbx">
          {preview.map((post, index) => <motion.li key={post.slug} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.08,
          ease: 'easeOut'
        }} data-id="element-127" data-mp="j12uiaarj5rg" data-mpi={index}>
              <Link to={`/blog/${post.slug}`} className="group flex h-full flex-col gap-4 rounded-2xl bg-white p-6 transition-colors hover:bg-[#E2FBFF]" data-id="element-128" data-mp="nrt2zwehjoqd">
                <p className="text-xs font-semibold uppercase tracking-wide text-[#0000FE]" data-id="element-129" data-mp="3s7aygxcjkxvf">
                  {post.category}
                </p>
                <h3 className="text-lg font-semibold leading-snug text-[#2D2D2D]" data-id="element-130" data-mp="a27mcso5rlli">
                  {post.title}
                </h3>
                <p className="text-sm leading-6 text-[#6F6F6F]" data-id="element-131" data-mp="1lfte8llek1aq">
                  {post.excerpt}
                </p>
                <p className="mt-auto pt-2 text-xs text-[#939598]" data-id="element-132" data-mp="1ghrurzk2dzyq">
                  {post.date} · {post.readTime}
                </p>
              </Link>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}